import { gql } from "@apollo/client";

export const InstalledBaseNodeAttributeOptionValueList = gql`
    query InstalledBaseNodeAttributeOptionValueList (
        $id: ID!,
        $pagination: Pagination,
        $search: SearchInput
    ) {
        installedBaseNodePropertyOptionValueList (propertyId: $id, search: $search) {
            total
            optionValues (pagination: $pagination) {
                id
                label
                value
                parentOptionValues {
                    id
                    value
                    label
                }
            }
        }
    }
`;



